import { ComputeExpenseLineItemTotalsUseCase } from './ComputeExpenseLineItemTotals'

export const computeExpenseLineItemTotalsUseCase =
  new ComputeExpenseLineItemTotalsUseCase()

export { ComputeExpenseLineItemTotalsUseCase } from './ComputeExpenseLineItemTotals'
export type { TaxType } from './ComputeExpenseLineItemTotals'
